module.exports = __webpack_public_path__ + "static/logo3-fec0ab1bdc287be8b1266b517aa9ad2b.svg";